import type { BaseKeyFunction } from "../../../../lib/types/baseKeyFunction";
import type { CommunityActivityFeedReferenceType } from "../../../../lib/types/enums/community/communityActivityFeedReferenceTypeEnum";

export type KeyCommunityActivityFeedProps = {
  id: number;
  types?: CommunityActivityFeedReferenceType[];
};

export const keyCommunityActivityFeed: BaseKeyFunction<
  KeyCommunityActivityFeedProps
> = ({ id, types }) => [
  "community-activity-feed",
  id.toString(),
  types ?? "all",
];
